<template>
  <LayoutTelas
    id="tela__servicos"
    :titulo="this.$route.meta.titulo"
    :isLoading="isLoading">

    <ServicosCadastroForm
      ref="formServico"
      :dados="dadosUsuario"
      @gravar="gravar" />

  </LayoutTelas>
</template>

<script>
import ServicosCadastroForm from './ServicosCadastroForm.vue'
import ServicosService from '../../../services/servicos.service'
import GeradorMensagens from '@/mixins/GeradorMensagens'

export default {
  name: 'ServicosCadastro',
  components: {
    ServicosCadastroForm,
  },
  mixins: [GeradorMensagens],
  data() {
    return {
      dadosUsuario: null,
      isLoading: false,
    }
  },
  beforeMount() {
    this.carregar()
  },
  methods: {
    async gravar(dados) {
      this.mostrarLoader()
      try {
        const retorno = await this.retornaMetodoGravacao(dados)
        this.tratarRespostaMsg(retorno)

        this.$refs.formServico.sair()
      } catch (error) {
        this.tratarRespostaMsg(error)
      } finally {
        this.mostrarLoader(false)
      }
    },
    retornaMetodoGravacao(dados) {
      return dados._id
        ? ServicosService.atualizar(dados)
        : ServicosService.gravar(dados)
    },
    async carregar() {
      if (this.$route.params.id) {
        this.mostrarLoader()
        try {
          this.dadosUsuario = await ServicosService.retornaPorId(this.$route.params.id)
        } catch (error) {
          this.tratarRespostaMsg(error)
          this.$router.push({ name: 'rota-servicos' })
        } finally {
          this.mostrarLoader(false)
        }
      }
    },
    mostrarLoader(mostrar = true) {
      this.isLoading = mostrar
    },
  },
}
</script>

<style lang="scss" scoped>
@import "@/scss/breakpoints.scss";

#tela__servicos {
  display: flex;
  flex-direction: column;
  max-width: 100%;

  @media (min-width: $medium-size) {
    min-width: $small-size;
  }
}

</style>
